import storeStorage from 'store'

export default {
    namespaced: true,

    state: {
        token: storeStorage.get('accessToken') || "",
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload.token
        },
    },
    getters: {
        token: (state) => state.token, 
    },
}